import Button from "@material-ui/core/Button";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grid from "@material-ui/core/Grid";
import Grow from "@material-ui/core/Grow";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import withStyles from "@material-ui/core/styles/withStyles";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import { updateAuthentication } from "Actions/AuthenticationAction";
import { getFormattedPermissions } from "Actions/commonAction";
import loader from "Assets/Gif/loader.gif";
import Reload from "Assets/Svg/reload-white.svg";
import syncimg from "Assets/Svg/undraw_synchronize.svg";
import CallOutNew from "Component/Headers/callOutNew";
import PageHeader from "Component/Headers/pageHeader";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import headersList from "Constants/headersList";
import get from "lodash/get";
import moment from "moment";
import { withSnackbar } from "notistack";
import React from "react";
import Helmet from "react-helmet";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../Actions/AxiosInstance";
import { CheckActionPermission } from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import clock from "../../../../../Assets/Icons/Clock-time/clock-time-16px.svg";
// import Sun from "../../../../../Assets/Images/sunny.png";
import DownloadIcon from "../../../../../Assets/newicons/action/download/outline/download-outline-16px.svg";
import attendanceimg from "../../../../../Assets/Svg/attendace-empty.svg";
import { DatePickerComponent } from "../../../../../Component/Custom";
import DefaultComp from "../../../../../Component/DefaultComp/Defaultstatecomp";
import DrawerHeader from "../../../../../Component/Headers/drawerHeader";
import { FEATUREKEYS } from "../../../../../Constants/Featurekeys";
import {
  convertDateForBackend,
  getEJ2CalenderMonthFormat,
  getFormattedDate,
  getFormattedTimewithAll,
  rawDataIntoExcel,
} from "../../../../../Utils";
import {
  getUserFormattedTimeFromAPIData,
  isIndateBeforeOutdate,
  istoday,
} from "../../../../../Utils/dates";
import Drawer from "./CustomDrawer";
import DrawerComponent from "./drawerComponent";
import "./index.style.css";
import SimpleTable from "./simpleTable";
import settingsIcon from "Assets/newicons/user-interface/setting-option/outline/setting-option-outline-16px.svg";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import downArrow from "../../../../../Assets/Svg/down-arrow-blue.svg";
import rghtArow from "../../../../../Assets/Svg/half-right-arrow-blue.svg";
import rightArrow from "../../../../../Assets/Svg/ArrowsRightIcon.png";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import { display, style, textAlign } from "@mui/system";
import ActionCenterReducer from "Reducers/EmployeeRequestCenterList";
import {
  setSaveProgress,
  removeSaveProgress,
} from "Actions/SaveProgressAction";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  expand: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(45deg)",
  },
  drawerPaper: {
    width: "30%",
  },
  stickyHeaderCell: {
    position: "sticky",
    top: 64,
    background: "#edf5fd",
    cursor: "pointer",
  },
});

class AttendanceLog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      employeeid: get(this.props, "AuthenticationAction.login.employeeid", ""),
      datareceived: false,
      policyAssigned: false,
      empList: [],
      overview: [],
      totalduration: [],
      averageduration: [],
      open: false,
      workRequestType: [],
      value: 0,
      expanded: false,
      designationList: [],
      employeeattendancelog: [],
      employeeattendancelogAdvanced: [],
      presentDays:0,
      absentDays:0,
      leaveDays:0,
      employeePunchedLogsDeleted: [],
      ShortDateFormat: null,
      TimeFormat: null,
      employeePunchedLogs: [],
      regularizeLog: [],
      recipient: null,
      SelectedEmpData: null,
      comment: null,
      selectedDate: new Date(),
      bulkRegularizeData: [
        {
          shiftdate: null,
          intime: null,
          indate: null,
          outtime: null,
          outdate: null,
          workrequesttypeid: null,
          comment: null,
          shiftList: [],
          shifttimingid: null,
          selectedShift: null,
        },
      ],
      shiftList: [],
      currentShift: false,
      currentshiftData: [],
      extraTimePolicyData: [],
      selectedShift: { shifttimingid: null, shiftbegintime: null },
      Shiftfromdate: "",
      Shifttodate: "",
      deleteOpen: [],
      empList1: [],
      asc: false,
      autoRegularize: false,
      bulkRegularize: false,
      IsClockin: false,
      AllLogs: false,
      assignedPolicy: false,
      extratime: false,
      Workrequest: false,
      right: false,
      isFromModule: false,
      openOptions: false,
      ischanged:false,
      headerData: [
        {
          id: "shiftdate",
          name: <FormattedMessage id="LbDate" defaultMessage="Date" />,
        },
        {
          id: "attendancestatusid",
          name: (
            <FormattedMessage
              id="LbAttendancestatus"
              defaultMessage="Attendance Status"
            />
          ),
        },
        {
          id: "intime",
          name: <FormattedMessage id="LbInTime" defaultMessage="In Time" />,
        },
        {
          id: "outtime",
          name: <FormattedMessage id="LbOutTime" defaultMessage="Out Time" />,
        },
        {
          id: "workduration",
          name: (
            <FormattedMessage
              id="LbWorkduration"
              defaultMessage="Work duration"
            />
          ),
        },
        {
          id: "breakduration",
          name: (
            <FormattedMessage
              id="LbBreakduration"
              defaultMessage="Break Duration"
            />
          ),
        },
        {
          id: "overtime",
          name: "Over Time",
        },
        {
          id: "lateby",
          name: <FormattedMessage id="LbLateby" defaultMessage="Late By" />,
        },
        {
          id: "earlycoming",
          name: <FormattedMessage id="LbEarlyby" defaultMessage="Early By" />,
        },

        // {
        //   id: "requeststatus",
        //   name: <FormattedMessage id="LbRequeststatus" defaultMessage="Request Status" />,
        // },
        {
          id: "popperOptions",
          name: (
            <span>
              {this.props.AuthenticationAction.login.features.find(
                (feature) =>
                  feature.featureid == FEATUREKEYS.exportAttendancelogs,
              ) &&
                this.props.AuthenticationAction.login.features.find(
                  (feature) =>
                    feature.featureid == FEATUREKEYS.exportAttendancelogs,
                ).permissions.editable && (
                  <span
                    className="display-block cursurpointer"
                    onClick={this.DownloadAtteLogs.bind(this)}
                  >
                    <img src={DownloadIcon} className="vertical-middle" />
                  </span>
                )}
            </span>
          ),
        },
      ],
      headerData2: [
        {
          id: "shiftdate",
          name: <FormattedMessage id="LbDate" defaultMessage="Date" />,
        },
        {
          id: "attendancestatusid",
          name: (
            <FormattedMessage
              id="LbAttendancestatus"
              defaultMessage="Attendance Status"
            />
          ),
        },
        {
          id: "intime",
          name: <FormattedMessage id="LbInTime" defaultMessage="In Time" />,
        },
        {
          id: "outtime",
          name: <FormattedMessage id="LbOutTime" defaultMessage="Out Time" />,
        },
        // {
        //   id: "workduration",
        //   name: (
        //     <FormattedMessage
        //       id="LbWorkduration"
        //       defaultMessage="Work duration"
        //     />
        //   ),
        // },
        {
          id: "popperOptions",
          name: (
            <span>
              {this.props.AuthenticationAction.login.features.find(
                (feature) =>
                  feature.featureid == FEATUREKEYS.exportAttendancelogs,
              ) &&
                this.props.AuthenticationAction.login.features.find(
                  (feature) =>
                    feature.featureid == FEATUREKEYS.exportAttendancelogs,
                ).permissions.editable && (
                  <span
                    className="display-block"
                    //onClick={this.DownloadAtteLogs.bind(this)}
                  >
                    {/* <img src={DownloadIcon} className="vertical-middle" /> */}
                  </span>
                )}
            </span>
          ),
        },
      ],
      showDiv:false,
      showLogDetail: false,
      showAdvanceOption:false,
      isloader:false,
      isDisable:false
    };
    this.SearchEmployee = this.SearchEmployee.bind(this);
    this.GetApproverList = this.GetApproverList.bind(this);
    this.syncapp = this.syncapp.bind(this);
    this.openOptions = this.openOptions.bind(this);
    this.toggleDivAttendanceSummary = this.toggleDivAttendanceSummary.bind(this); 
  }

  componentWillMount() {
    const [isTrue, permissions] = CheckActionPermission("attendanceLogs");

    if (isTrue) {
      this.props.ChangeLanguage("attendancelogs");
      const DateFormat = get(
        this.props,
        "SubscriptionInfo.SubscriptionData.dateformatname",
        "",
      );
      let ShortDateFormat = DateFormat.split(" ");
      const TimeFormat = ShortDateFormat[2]
        ? `${ShortDateFormat[1]} ${ShortDateFormat[2]}`
        : ShortDateFormat[1];
      ShortDateFormat = ShortDateFormat[0];
      let time;
      const dateformat = window.localStorage.getItem("dateformat");
      time = dateformat
        ? dateformat.includes == "AM" || dateformat.includes == "PM"
          ? 12
          : 24
        : 24;
      this.setState({ ShortDateFormat, TimeFormat, permissions, time });
    } else {
      // backToHome();
      this.setState({ permissiondenied: true });
    }
  }

  async componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("attendanceLogs");
    if (isTrue) {
      const isFromModule = this.props.match.path == "/app/track/attendance";
      const { employeeid } = this.props.AuthenticationAction.login;
      if (!isFromModule) {
        const employeeid = get(
          this.props,
          "AuthenticationAction.login.employeeid",
          "",
        );
        try {
          this.GetEmpDoj(employeeid);
          const defaultshiftdata = await instance.get(
            `attendance/defaultshiftemployee/${employeeid}`,
          );
          if (get(defaultshiftdata, "data.result[0]", "")) {
            this.setdefaultshiftdatasuccess();
            this.GetWorkRequest();
            this.GetAllDesignationList();
            this.GetAttendanceLog();
          } else {
            this.setdefaultshiftdataerr();
          }
        } catch (error) {
          this.setdefaultshiftdataerr();
        }
      } else if (this.props.AuthenticationAction.login.masterprofileid != 9) {
        this.GetEmployeeDetails();
      }

      this.setState({ isFromModule, employeeid });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  openOptions(value) {
    this.setState({ openOptions: value, showAdvanceOption:true });
  }

  handleClickShowLogDetail = () => {
    this.setState({ isloader: true , isDisable:true});
    
    //this.setState({ showLogDetail: !this.state.showLogDetail });
    
    if(!this.state.showLogDetail){
      this.GetAdditionalAttendanceLog(2);
    }else{
        this.GetAdditionalAttendanceLog(1);
    }
   // this.setState({ isloader: false });
  };

  setdefaultshiftdataerr = () => {
    // this.props.enqueueSnackbar(ErrorMessages.E1080, { variant: "error" });
    this.setState({ datareceived: true, policyAssigned: false });
  };

  setdefaultshiftdatasuccess = () => {
    // this.props.enqueueSnackbar(ErrorMessages.E1080, { variant: "error" });
    this.setState({ datareceived: true, policyAssigned: true });
  };

  async syncapp() {
    const { AuthenticationAction } = this.props;
    const hardrefreshapp = () => {
      if (caches) {
        caches.keys().then((keys) => {
          for (const key of keys) caches.delete(key);
        });
      }
      window.location.reload(true);
    };
    try {
      const permissionsresult = await instance.get(
        "subscription/getuserpermssion",
      );
      const plans = await instance.post(`superuser/getcompanyplanconfig`, {
        accountid:
          AuthenticationAction.login && AuthenticationAction.login.accountid,
        subscriptionid:
          AuthenticationAction.login &&
          AuthenticationAction.login.subscriptionid,
      });
      const objsuportplan = plans.data.result[0]
        ? plans.data.result.find((x) => x.typeid == 1)
        : null;
      const objpriceplan = plans.data.result[0]
        ? plans.data.result.find((x) => x.typeid == 2)
        : null;
      let logindata = {
        ...AuthenticationAction.login,
        objsuportplan,
        objpriceplan,
      };
      const migrationlist = await instance.get(
        "superuser/getconfigmigrationinit",
      );
      logindata.migration = migrationlist.data.result;
      logindata.features = getFormattedPermissions(
        permissionsresult.data.result,
      );

      const isAdmin = logindata.masterprofileid >= 9;
      let hasAttendanceAppAccess = isAdmin;
      let hasLeaveAppAccess = isAdmin;
      let hasExpenseAppAccess = isAdmin;
      let hasPerformAppAccess = isAdmin;
      let hasCompensatorAccess = isAdmin;
      const hasDriveAccess = isAdmin;
      const hasLetterAccess = isAdmin;

      if (!isAdmin) {
        try {
          let data = {
            featurekey: "attendanceLogs",
            workflowfortypeid: 2,
          };
          const attendanceapproverreportee = await instance.post(
            `attendance/approverreportee`,
            data,
          );
          // hasAttendanceAppAccess =
          //   isAdmin || get(attendanceapproverreportee, "data.result[0]", "");
          hasAttendanceAppAccess = get(
            attendanceapproverreportee,
            "data.result[0]",
            "",
          );

          data = {
            featurekey: "leaveBalanceAndHistory",
            workflowfortypeid: 3,
          };
          const leaveapproverreportee = await instance.post(
            `attendance/approverreportee`,
            data,
          );
          // hasLeaveAppAccess =
          //   isAdmin || get(leaveapproverreportee, "data.result[0]", "");

          hasLeaveAppAccess = get(leaveapproverreportee, "data.result[0]", "");

          data = {
            featurekey: "employeeExpense",
            workflowfortypeid: 5,
          };
          const expenseapproverreportee = await instance.post(
            `attendance/approverreportee`,
            data,
          );
          // hasExpenseAppAccess =
          //   isAdmin || get(expenseapproverreportee, "data.result[0]", "");

          hasExpenseAppAccess = get(
            expenseapproverreportee,
            "data.result[0]",
            "",
          );

          const checkiscompensator = await instance.get(
            `expense/checkiscompensator`,
          );
          // hasCompensatorAccess =
          //   isAdmin ||
          //   get(checkiscompensator, "data.result[0].iscompensator", "");

          hasCompensatorAccess = get(
            checkiscompensator,
            "data.result[0].iscompensator",
            "",
          );

          data = {
            featurekey: "degree",
            workflowfortypeid: 6,
          };
          const performapproverreportee = await instance.post(
            `attendance/approverreportee`,
            data,
          );
          // hasPerformAppAccess =
          //   isAdmin || get(performapproverreportee, "data.result[0]", "");

          hasPerformAppAccess = get(
            performapproverreportee,
            "data.result[0]",
            "",
          );
        } catch (err) {
          this.props.enqueueSnackbar(
            get(
              err,
              "responses.data.error.message",
              "Please check username and password",
            ),
            { variant: "error" },
          );
          this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
            IsFulfilled: true,
            data: null,
          });
          return false;
        }
      }

      if (hasCompensatorAccess) {
        get(logindata, "features", []).push({
          hasAppAccess: true,
          permissions: {
            readOnly: false,
            editable: true,
          },
          featureid: 314,
        });
      }

      logindata = {
        ...logindata,
        features: get(logindata, "features", []).map((feature) => {
          const res = feature;
          if (feature.featureid == FEATUREKEYS.attendance) {
            res.hasAppAccess = hasAttendanceAppAccess;
          } else if (feature.featureid == FEATUREKEYS.leave) {
            res.hasAppAccess = hasLeaveAppAccess;
          } else if (feature.featureid == FEATUREKEYS.employeeExpense) {
            res.hasAppAccess = hasExpenseAppAccess;
          } else if (feature.featureid == FEATUREKEYS.adminDashboard) {
            res.hasAppAccess = hasCompensatorAccess;
          } else if (feature.featureid == FEATUREKEYS.companyDrive) {
            res.hasAppAccess = hasDriveAccess;
          } else if (feature.featureid == FEATUREKEYS.letters) {
            res.hasAppAccess = hasLetterAccess;
          } else if (feature.featureid == FEATUREKEYS.degree) {
            res.hasAppAccess = hasPerformAppAccess;
          }
          return res;
        }),
      };

      this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
        IsFulfilled: true,
        data: logindata,
      });
      this.setState({ anchorEl: null, isexpand: false });
      hardrefreshapp();
    } catch (e) {
      this.setState({ anchorEl: null, isexpand: false });
      this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
        IsFulfilled: true,
        data: null,
      });
    }
  }

  GetEmployeeDetails() {
    const data = {
      featurekey: "attendanceLogs",
      workflowfortypeid: 2,
    };
    instance
      .post(`attendance/approverreportee`, data)
      .then((result) => {
        const arrAllEmp = result.data.result;
        const opt = [];
        opt.push({
          label: "Active",
          options: arrAllEmp.filter(
            (employee) => employee.employeestatusid == 1,
          ),
        });

        opt.push({
          label: "In-Active",
          options: arrAllEmp.filter(
            (employee) => employee.employeestatusid == 3,
          ),
        });

        this.setState({ empList1: opt });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetEmpDoj(id) {
    const empid = id ? id : this.state.employeeid;
    const url = `leaves/initleaveapply/${empid}`;
    instance
      .get(url)
      .then((result) => {
        this.setState({ empdoj: result.data.result[0].doj });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  SearchEmployee(search) {
    if (search.length < 1) return;
    if (
      (!this.state.prevSearch || this.state.prevSearch != search) &&
      search.length >= 1
    ) {
      const URL = `/subscription/employeelist`;
      const data = {
        searchfor: search,
        statusid: null,
        featurekey: "attendanceLogs",
      };
      instance
        .post(URL, data)
        .then((result) => {
          const arrAllEmp = result.data.result;
          const opt = [];
          opt.push({
            label: "Active",
            options: arrAllEmp.filter(
              (employee) => employee.employeestatusid == 1,
            ),
          });

          opt.push({
            label: "In-Active",
            options: arrAllEmp.filter(
              (employee) => employee.employeestatusid == 3,
            ),
          });

          this.setState({ empList: opt });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  async UpdateSelectedEmpId(selectedItem) {
    try {
      this.setState(
        {
          employeeid: selectedItem ? selectedItem.displayvalue : null,
          SelectedEmpData: selectedItem,
        },
        () => {
          selectedItem && this.GetEmpDoj(this.state.employeeid);
        },
      );
      if (selectedItem) {
        const defaultshiftdata = await instance.get(
          `attendance/defaultshiftemployee/${selectedItem.displayvalue}`,
        );
        if (get(defaultshiftdata.data.result, "[0]", "")) {
          if (selectedItem && selectedItem.displayvalue) {
            this.GetAttendanceLog(1);
          }
        } else {
          this.setdefaultshiftdataerr();
        }
      }
    } catch (e) {
      this.setdefaultshiftdataerr();
    }
  }

  async UpdateSelectedEmpId1(selectedItem) {
    try {
      this.setState(
        {
          employeeid: selectedItem ? selectedItem.displayvalue : null,
          SelectedEmpId: selectedItem.displayvalue,
          SelectedEmpData: selectedItem,
        },
        () => {
          selectedItem && this.GetEmpDoj(this.state.employeeid);
        },
      );
      if (selectedItem) {
        const defaultshiftdata = await instance.get(
          `attendance/defaultshiftemployee/${selectedItem.displayvalue}`,
        );
        if (get(defaultshiftdata.data.result, "[0]", "")) {
          if (selectedItem && selectedItem.displayvalue) {
            this.GetAttendanceLog(1);
          }
        } else {
          this.setdefaultshiftdataerr();
        }
      }
    } catch (e) {
      this.setdefaultshiftdataerr();
    }
  }

  async GetApproverList() {
    const data = {
      workflowfortypeid: 2,
      withadmin: true,
      employeeid: this.state.employeeid,
    };
    try {
      const result = await instance.post(
        "leaves/employeeapprovalrecipients",
        data,
      );
      if (get(result, "data.result[0]", "")) {
        let recipientdata = get(result, "data.result", []).map((x) => ({
          approveremployeeid: x.employeeid,
          levelid: x.levelid,
        }));
        if (recipientdata.length == 0) {
          recipientdata = null;
        }
        this.setState({
          recipient: [...recipientdata],
          originalrecipient: result.data.result,
        });
      }
    } catch (err) {
      console.log("err: ", err);
      // this.props.enqueueSnackbar("Recipients not found", { variant: "error" });
    }
  }

  GetAttendanceLog = (accesstypeid) => {
    const { state } = this;
    const { selectedDate } = this.state;

    this.setState({
      isloading: true,
    });

    let getFromDate = "";
    let getToDate = "";
    if (
      !isIndateBeforeOutdate({
        indate: moment(selectedDate).startOf("month"),
        outdate: moment().startOf("month"),
      })
    ) {
      getFromDate = moment(selectedDate).startOf("month").format("YYYY-MM-DD");
      getToDate = moment().format("YYYY-MM-DD");
    } else {
      getFromDate = moment(selectedDate).startOf("month").format("YYYY-MM-DD");
      getToDate = moment(selectedDate).endOf("month").format("YYYY-MM-DD");
    }

    const { employeeid } = this.state;

    const data = {
      employeeid,
      fromdate: getFromDate,
      todate: getToDate,
      accesstypeid: accesstypeid?accesstypeid:1,
    };
    instance
      .post(`attendance/getattendancelog`, data)
      .then((result) => {
        
        Object.keys(result.data.result[0]).forEach((keys) => {
          if( data.accesstypeid == 1){
            state[keys] = result.data.result[0][keys];
          }else if( data.accesstypeid == 2 ){
            state['employeeattendancelogAdvanced'] = result.data.result[0][keys];
          }
        });

        const presentDayArr = result.data.result[0]['employeeattendancelog'].filter((employee) => employee.attendancestatusid == 1);
        const absentDayArr = result.data.result[0]['employeeattendancelog'].filter((employee) => employee.attendancestatusid == 2);
        //const leaveDayArr = 0;

        this.setState(
          {
            ...state,
            presentDays: presentDayArr.length? presentDayArr.length:0,
            absentDays: absentDayArr.length? absentDayArr.length:0,
            leaveDays: 0,
            value: 0,
            autoRegularize: false,
            bulkRegularize: false,
            IsClockin: false,
            AllLogs: false,
            assignedPolicy: false,
            currentShift: false,
            Workrequest: false,
            right: false,
            datareceived: true,
            policyAssigned: true,
            isloading: false,
            showLogDetail : data.accesstypeid==2?true:false,
            isloader:false,

          },
          () => this.GetApproverList(),
        );
      })
      .catch((error) => {
        this.setState({ datareceived: true, isloading: false });
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  GetAdditionalAttendanceLog = (accesstypeid) => {
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    if (!issaveinprogress) {
      this.props.setSaveProgress(true);

    const { state } = this;
    const { selectedDate } = this.state;

    let getFromDate = "";
    let getToDate = "";
    if (
      !isIndateBeforeOutdate({
        indate: moment(selectedDate).startOf("month"),
        outdate: moment().startOf("month"),
      })
    ) {
      getFromDate = moment(selectedDate).startOf("month").format("YYYY-MM-DD");
      getToDate = moment().format("YYYY-MM-DD");
    } else {
      getFromDate = moment(selectedDate).startOf("month").format("YYYY-MM-DD");
      getToDate = moment(selectedDate).endOf("month").format("YYYY-MM-DD");
    }

    const { employeeid } = this.state;

    const data = {
      employeeid,
      fromdate: getFromDate,
      todate: getToDate,
      accesstypeid: accesstypeid?accesstypeid:1,
    };
    instance
      .post(`attendance/getattendancelog`, data)
      .then((result) => {
        
        Object.keys(result.data.result[0]).forEach((keys) => {
          if( data.accesstypeid == 1){
            state[keys] = result.data.result[0][keys];
          }else if( data.accesstypeid == 2 ){
            state['employeeattendancelogAdvanced'] = result.data.result[0][keys];
          }
        });

        // const presentDayArr = result.data.result[0]['employeeattendancelog'].filter((employee) => employee.attendancestatusid == 1);
        // const absentDayArr = result.data.result[0]['employeeattendancelog'].filter((employee) => employee.attendancestatusid == 2);
        // //const leaveDayArr = 0;

        this.setState(
          {
            ...state,
            // presentDays: presentDayArr.length? presentDayArr.length:0,
            // absentDays: absentDayArr.length? absentDayArr.length:0,
            // leaveDays: 0,
            value: 0,
            autoRegularize: false,
            bulkRegularize: false,
            IsClockin: false,
            AllLogs: false,
            assignedPolicy: false,
            currentShift: false,
            Workrequest: false,
            right: false,
            datareceived: true,
            policyAssigned: true,
            isloader: false,
            showLogDetail: data.accesstypeid == 2 ? true : false,
            isDisable:false
          },
         
          //() => this.GetApproverList(),
        );
        this.props.removeSaveProgress()
      })
      .catch((error) => {
        this.props.removeSaveProgress()
        this.setState({ datareceived: true, isloading: false, isloader:false});
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
    }
  };

  UpdateSelectedDesignationIds(selectedItems) {
    let designationIds = [];
    for (const item of selectedItems) {
      designationIds.push(item.displayvalue);
    }
    designationIds.length > 0 && (designationIds = null);
    this.setState({ SelectedDesignationIds: selectedItems, designationIds });
  }

  GetAllDesignationList() {
    instance
      .get(`subscription/alldesignation`)
      .then((result) => {
        this.setState({ designationList: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetWorkRequest = (shiftDate) => {
    const data = {
      employeeid: this.state.employeeid,
      shiftdate: convertDateForBackend(moment(shiftDate).format("YYYY-MM-DD")),
    };
    instance
      .post("attendance/getworkrequest", data)
      .then((result) => {
        try {
          this.setState({
            workRequestType: result.data.result,
            autoRegularize: false,
            bulkRegularize: false,
            IsClockin: false,
            AllLogs: false,
            assignedPolicy: false,
            currentShift: false,
            Workrequest: false,
            right: false,
          });
        } catch (err) {}
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  dateOnSelect(val) {
    this.setState({ selectedDate: val.value }, () => this.GetAttendanceLog(1));
  }

  handleToggle = (index, e) => {
    if(this.state.showLogDetail){ 
      const employeeattendancelogAdvanced = [...this.state.employeeattendancelogAdvanced];
      if (employeeattendancelogAdvanced[index].open) {
        employeeattendancelogAdvanced[index].open = false;
      } else {
        employeeattendancelogAdvanced[index].open = true;
      }
      this.setState({ employeeattendancelogAdvanced, anchorEl: e.currentTarget });
    
    }else{
      const employeeattendancelog = [...this.state.employeeattendancelog];
      if (employeeattendancelog[index].open) {
        employeeattendancelog[index].open = false;
      } else {
        employeeattendancelog[index].open = true;
      }
      this.setState({ employeeattendancelog, anchorEl: e.currentTarget });
   }
  };

  handleClose = (index) => {
    if( this.state.showLogDetail){
      const employeeattendancelogAdvanced = [...this.state.employeeattendancelogAdvanced];
      employeeattendancelogAdvanced[index].open = false;
      this.setState({ employeeattendancelogAdvanced });
    }else{
    const employeeattendancelog = [...this.state.employeeattendancelog];
    employeeattendancelog[index].open = false;
    this.setState({ employeeattendancelog });
    }
  };

  closeDrawer = (rightFlag) => {
    this.setState({
      right: rightFlag || false,
      expanded: false,
      autoRegularize: false,
      Workrequest: false,
      bulkRegularize: false,
      IsClockin: false,
    });
  };

  toggleDivAttendanceSummary ( ischanged ) {
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    if (!issaveinprogress) {
      this.props.setSaveProgress(true);
        this.setState({isDisable: true})
        const { state } = this;
        const { selectedDate } = this.state;

            if( !this.state.showDiv ){

              // this.setState({ isloading:true})
                let getFromDate = "";
                let getToDate = "";
                if (
                  !isIndateBeforeOutdate({
                    indate: moment(selectedDate).startOf("month"),
                    outdate: moment().startOf("month"),
                  })
                ) {
                  getFromDate = moment(selectedDate).startOf("month").format("YYYY-MM-DD");
                  getToDate = moment().format("YYYY-MM-DD");
                } else {
                  getFromDate = moment(selectedDate).startOf("month").format("YYYY-MM-DD");
                  getToDate = moment(selectedDate).endOf("month").format("YYYY-MM-DD");
                }

                const { employeeid } = this.state;

                const data = {
                  employeeid,
                  fromdate: getFromDate,
                  todate: getToDate
                };
                instance
                  .post(`attendance/getattendancsummary`, data)
                  .then((result) => {
                    Object.keys(result.data.result[0]).forEach((keys) => {
                      state[keys] = result.data.result[0][keys];
                    });
                    this.setState(
                      {
                        ...state,
                        value: 0,
                        autoRegularize: false,
                        bulkRegularize: false,
                        IsClockin: false,
                        AllLogs: false,
                        assignedPolicy: false,
                        currentShift: false,
                        Workrequest: false,
                        right: false,
                        datareceived: true,
                        policyAssigned: true,
                        isloading: false,
                        showDiv: true,
                        isDisable:false
                      },
                      //() => this.GetApproverList(),
                    );
                    this.props.removeSaveProgress();
                  })
                  .catch((error) => {
                    this.props.removeSaveProgress();
                    this.setState({ datareceived: true, isloading: false, showDiv: false});
                    this.props.enqueueSnackbar(
                      error.response ? error.response.data.error.message : error.message,
                      { variant: "error" },
                    );
                  });
            }else{
              this.props.removeSaveProgress();
              this.setState({showDiv : !this.state.showDiv, 
                isDisable:false,
              overview:[],
            averageduration:[],
          totalduration:[]});
            }
    }
    
  }

  toggleDrawer = (side, open, flag, data) => () => {
    if (flag == "extratime") {
      this.setState({
        AllLogs: false,
        assignedPolicy: false,
        autoRegularize: false,
        bulkRegularize: false,
        currentShift: false,
        extratime: true,
        [side]: open,
        deleteOpen: [],
        Workrequest: false,
        IsClockin: false,
        currentclockindata: data,
      });
    } else if (flag == "IsClockin") {
      this.setState({
        AllLogs: false,
        assignedPolicy: false,
        autoRegularize: false,
        bulkRegularize: false,
        currentShift: false,
        [side]: open,
        extratime: false,
        deleteOpen: [],
        Workrequest: false,
        IsClockin: true,
        currentclockindata: data,
      });
    } else if (flag == "WorkRequest") {
      this.setState({
        AllLogs: false,
        assignedPolicy: false,
        autoRegularize: false,
        bulkRegularize: false,
        currentShift: false,
        [side]: open,
        extratime: false,
        deleteOpen: [],
        Workrequest: true,
        IsClockin: false,
      });
    } else if (flag == "AllLogs") {
      this.setState({
        selectedshiftdate: data.shiftdate,
        selectedshiftdateObj: data,
        AllLogs: true,
        assignedPolicy: false,
        extratime: false,
        autoRegularize: false,
        bulkRegularize: false,
        currentShift: false,
        [side]: open,
        deleteOpen: [],
        IsClockin: false,
        Workrequest: false,
      });
    } else if (flag == "currentshift") {
      const shiftdatefull = new Date(data.shiftdate);
      instance
        .post("attendance/actualshifttiming", {
          shiftdate: moment(shiftdatefull).format("YYYY-MM-DD"),
          shiftid: data.shiftid || null,
          employeeid: this.state.employeeid,
          shifttimingid: data.shifttimingid || null,
        })
        .then((result) => {
          if (result.data.result.length > 0) {
            this.setState({
              currentshiftData: result.data.result[0],
              AllLogs: false,
              extratime: false,
              assignedPolicy: false,
              autoRegularize: false,
              bulkRegularize: false,
              currentShift: true,
              [side]: open,
              IsClockin: false,
              workRequest: false,
            });
          } else {
            this.props.enqueueSnackbar("No Shift Assigned", {
              variant: "error",
            });
          }
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });

      instance
        .post("attendance/empetpolicy", {
          shiftdate: moment(shiftdatefull).format("YYYY-MM-DD"),

          employeeid: this.state.employeeid,
        })
        .then((result) => {
          if (result.data.result.length > 0) {
            this.setState({
              extraTimePolicyData: result.data.result[0],
            });
          } else {
            this.props.enqueueSnackbar("No extra time policy assigned", {
              variant: "error",
            });
          }
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    } else if (flag == "AutoRegularize") {
      const regularizeLog = [];
      const absentLog = this.state.employeeattendancelog.filter(
        (x) => x.attendancestatusid == 2,
      );
      for (const log of absentLog) {
        regularizeLog.push({
          shiftid: log.shiftid,
          shiftdate: moment(log.shiftdate).format("YYYY-MM-DD"),
          attendancelogid: log.attendancelogid,
          empshiftplannerid: log.empshiftplannerid,
          devicepolicyid: log.devicepolicyid,
          weeklyoffpolicyid: log.weekoffpolicyid,
          attendancepolicyid: log.attendancepolicyid,
          shifttimingid: log.shifttimingid,
        });
      }
      this.setState({
        regularizeLog,
        AllLogs: false,
        extratime: false,
        assignedPolicy: false,
        autoRegularize: true,
        bulkRegularize: false,
        currentShift: false,
        [side]: open,
        IsClockin: false,
        Workrequest: false,
      });
    } else if (flag == "BulkRegularize") {
      this.setState(
        {
          AllLogs: false,
          assignedPolicy: false,
          autoRegularize: false,
          bulkRegularize: true,
          currentShift: false,
          extratime: false,
          [side]: open,
          deleteOpen: [],
          IsClockin: false,
          Workrequest: false,
        },
        () => {
          let bulkRegularizeData = [];
          bulkRegularizeData = [
            {
              shiftdate: null,
              intime: null,
              indate: null,
              outtime: null,
              outdate: null,
              workrequesttypeid: null,
              comment: null,
              shiftList: [],
              shifttimingid: null,
              selectedShift: null,
            },
          ];
          let logData = data ? data: [];
          
          this.setState({ bulkRegularizeData, logData });

        },
      );
    } else if (!flag) {
      this.setState({
        [side]: open,
        expanded: false,
      });
    }
  };

  AttendanceStatus(logs) {
    const flagArray = [
      { key: "isweekoff", value: "(W.O)" },
      { key: "isholiday", value: "(H)" },
      { key: "isoptionalholiday", value: "(O.H)" },
      // { key: "isonfirsthalfleave", value: "(F.H)" },
      // { key: "isonsecondhalfleave", value: "(S.H)" },
      // { key: "isonfulldayleave", value: "(F.D)" },
      { key: "isonhourlyleave", value: "(H.L)" },
    ];
    const leaveType = [
      { key: "leavestarttypeid", type: 2, value: "(F.H)" },
      { key: "leavestarttypeid", type: 3, value: "(S.H)" },
      { key: "leavestarttypeid", type: 1, value: "(F.D)" },
    ];
    let returnString = "";
    switch (Number(logs.attendancestatusid)) {
      case 0: {
        for (const flag of flagArray) {
          if (logs[flag.key]) {
            returnString += flag.value;
            // break;
          }
        }
        const index = leaveType.findIndex(
          (x) => x.type == logs.leavestarttypeid,
        );
        if (index >= 0) {
          returnString += leaveType[index].value;
        }
        return returnString;
      }
      case 1: {
        returnString = "Present ";
        for (const flag of flagArray) {
          if (logs[flag.key]) {
            returnString += flag.value;
            // break;
          }
        }
        return returnString;
      }
      case 2: {
        return (returnString = "Absent");
      }
      default:
        return (returnString = "-");
    }
  }

  DeleteAttendanceLog(logs) {
    const data = {
      // "attendancelogid": logs.attendancelogid,
      shifttimingid: logs.shifttimingid || null,
      employeeid: this.state.employeeid,
      shiftdate: logs.shiftdate || null,
      empshiftplannerid: logs.empshiftplannerid || null,
      shiftid: logs.shiftid || null,
      devicepolicyid: logs.devicepolicyid || null,
      weekoffpolicyid: logs.weekoffpolicyid || null,
      attendancepolicyid: logs.attendancepolicyid || null,
    };
    this.props.enqueueSnackbar(
      `WARNING! You're about to delete all logs for ${moment(
        logs.shiftdate,
      ).format("DD MMM, YYYY")}. Are you sure?`,
      {
        variant: "warning",
        action: [
          <Button
            variant="outlined"
            color="inherit"
            className="margin-right-16"
            size="small"
            onClick={() => {
              instance
                .post("attendance/deletetransactionlog", data)
                .then(() => {
                  this.props.enqueueSnackbar("logs deleted succesfully", {
                    variant: "success",
                  });
                  this.GetAttendanceLog(1);
                })
                .catch((error) => {
                  this.props.enqueueSnackbar(
                    error.response
                      ? error.response.data.error.message
                      : error.message,
                    { variant: "error" },
                  );
                });
            }}
          >
            Delete
          </Button>,
          <Button
            color="inherit"
            size="small"
            onClick={() => this.props.closeSnackbar()}
          >
            Cancel
          </Button>,
        ],
      },
    );
  }

  renderLogs = (logs, index) => {
      const deleteAttendancelogs =
      this.props.AuthenticationAction.login.features.find(
        (feature) => feature.featureid == FEATUREKEYS.deleteAttendancelogs,
      );
    const checkbulkreg = this.props.AuthenticationAction.login.features.find(
      (feature) => feature.featureid == FEATUREKEYS.updateAttendancelogs,
    );
    if (logs.isweekoff && logs.attendancestatusid == 0) {
      return (
        <TableRow class="weekly-off-row">
          {/* <TableCell>{DateConversion(logs.shiftdate, ShortDateFormat)}</TableCell> */}
          <TableCell style={{ textAlign: "center" }}>{`${moment(
            logs.shiftdate,
          ).format("DD/MM")}, ${moment(logs.shiftdate).format(
            "ddd",
          )}`}</TableCell>
          <TableCell
            style={{ textAlign: "center" }}
            colSpan="8"
            className="text-align-center weeklyofflog"
          >
            {logs.weeklyoff} weekly off
          </TableCell>
          <TableCell style={{ textAlign: "center" }}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              onClick={ this.handleToggle.bind(this, index)}
              className="cursurpointer"
            >
              <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
            </svg>
          </TableCell>
          <Popper
            open={logs.open}
            anchorEl={this.state.anchorEl}
            transition
            disablePortal
            className="attendancelog-menu"
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "right top" : "right bottom",
                }}
              >
                <Paper>
                  <ClickAwayListener
                    onClickAway={this.handleClose.bind(this, index)}
                  >
                    <MenuList>
                      {istoday(logs.shiftdate) && (
                        <MenuItem
                          onClick={this.toggleDrawer(
                            "right",
                            true,
                            "IsClockin",
                          )}
                        >
                          Clock-in
                        </MenuItem>
                      )}
                      <MenuItem
                        onClick={this.toggleDrawer("right", true, "AllLogs", {
                          shiftdate: logs.shiftdate,
                          shiftid: logs.shiftid,
                          shifttimingid: logs.shifttimingid,
                        })}
                      >
                        View all logs
                      </MenuItem>
                      {/* <MenuItem onClick={this.toggleDrawer('right', true, "AssignedPolicy")}>Assigned Policy</MenuItem> */}
                      {
                        <MenuItem
                          onClick={this.toggleDrawer(
                            "right",
                            true,
                            "currentshift",
                            {
                              shiftdate: logs.shiftdate,
                              shiftid: logs.shiftid,
                              shifttimingid: logs.shifttimingid,
                            },
                          )}
                        >
                          View Shift & policy info
                        </MenuItem>
                      }
                      {deleteAttendancelogs &&
                      deleteAttendancelogs.permissions.editable &&
                      logs.intime ? (
                        <MenuItem
                          onClick={this.DeleteAttendanceLog.bind(this, logs)}
                        >
                          Delete all logs
                        </MenuItem>
                      ) : undefined}

                    {/* { checkbulkreg && checkbulkreg.permissions.editable &&
                    logs.intime ? (
                      <MenuItem
                      onClick={this.toggleDrawer(
                        "right",
                        true,
                        "BulkRegularize",
                        logs
                      )}
                      >
                        Attendance update
                      </MenuItem>
                    ) : undefined} */}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </TableRow>
      );
    } else if (
      (logs.isholiday || logs.isoptionalholiday) &&
      logs.attendancestatusid == 0
    ) {
      return (
        <TableRow class="hightlightOnHover">
          <TableCell style={{ textAlign: "center" }}>{`${moment(
            logs.shiftdate,
          ).format("DD/MM")}, ${moment(logs.shiftdate).format(
            "ddd",
          )}`}</TableCell>
          <TableCell
            style={{ textAlign: "center" }}
            colSpan="8"
            className="text-align-center weeklyofflog"
          >
            {logs.isholiday ? "Holiday" : "Optional Holiday"}
          </TableCell>
          <TableCell style={{ textAlign: "center" }}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              onClick={ this.handleToggle.bind(this, index)}
              className="cursurpointer"
            >
              <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
            </svg>
          </TableCell>
          <Popper
            open={logs.open}
            anchorEl={this.state.anchorEl}
            transition
            disablePortal
            className="attendancelog-menu"
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "right top" : "right bottom",
                }}
              >
                <Paper>
                  <ClickAwayListener
                    onClickAway={this.handleClose.bind(this, index)}
                  >
                    <MenuList>
                      {istoday(logs.shiftdate) && (
                        <MenuItem
                          onClick={this.toggleDrawer(
                            "right",
                            true,
                            "IsClockin",
                          )}
                        >
                          Clock-in
                        </MenuItem>
                      )}
                      <MenuItem
                        onClick={this.toggleDrawer("right", true, "AllLogs", {
                          shiftdate: logs.shiftdate,
                          shiftid: logs.shiftid,
                          shifttimingid: logs.shifttimingid,
                        })}
                      >
                        View all logs
                      </MenuItem>
                      {/* <MenuItem onClick={this.toggleDrawer('right', true, "AssignedPolicy")}>Assigned Policy</MenuItem> */}
                      {
                        <MenuItem
                          onClick={this.toggleDrawer(
                            "right",
                            true,
                            "currentshift",
                            {
                              shiftdate: logs.shiftdate,
                              shiftid: logs.shiftid,
                              shifttimingid: logs.shifttimingid,
                            },
                          )}
                        >
                          View Shift & policy info
                        </MenuItem>
                      }
                      {deleteAttendancelogs &&
                      deleteAttendancelogs.permissions.editable &&
                      logs.intime ? (
                        <MenuItem
                          onClick={this.DeleteAttendanceLog.bind(this, logs)}
                        >
                          Delete all logs
                        </MenuItem>
                      ) : undefined}
                      {/* { checkbulkreg && checkbulkreg.permissions.editable &&
                    logs.intime ? (
                      <MenuItem
                      onClick={this.toggleDrawer(
                        "right",
                        true,
                        "BulkRegularize",
                        logs
                      )}
                      >
                        Attendance update
                      </MenuItem>
                    ) : undefined} */}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </TableRow>
      );
    }
    return (
      <TableRow class="hightlightOnHover">
        <TableCell style={{ textAlign: "center" }}>{`${moment(
          logs.shiftdate,
        ).format("DD/MM")}, ${moment(logs.shiftdate).format(
          "ddd",
        )}`}</TableCell>

      {logs.attendancestatusid == 2 ? 
        <TableCell
          style={{
            color: "red",
            textAlign: "center",
          }}
        >
          {
            logs.statusstring
            // this.AttendanceStatus(logs)
          }
        </TableCell> : 
        <TableCell
          style={{
            color:"#000",
            textAlign: "center",
          }}
        >
          {
            logs.statusstring
            // this.AttendanceStatus(logs)
          }
        </TableCell> }
        <TableCell style={{ textAlign: "center" }}>
          {getUserFormattedTimeFromAPIData(logs.intime)}
        </TableCell>
        <TableCell style={{ textAlign: "center" }}>
          {getUserFormattedTimeFromAPIData(logs.outtime)}
        </TableCell>
        {this.state.showLogDetail && (
        <TableCell style={{ textAlign: "center" }}>
          {(logs.workduration)? logs.workduration : ""}
        </TableCell> )}

        {this.state.showLogDetail && (
        <TableCell style={{ textAlign: "center" }}>
          {(logs.breakduration)? logs.breakduration : ""}
        </TableCell>)}
        {this.state.showLogDetail && (
        <TableCell style={{ textAlign: "center" }}>{(logs.overtime)? logs.overtime : ""}</TableCell>)}
        {this.state.showLogDetail && (
        <TableCell style={{ textAlign: "center" }}>{(logs.lateby)? logs.lateby : ""}</TableCell>)}
        {this.state.showLogDetail && (
        <TableCell style={{ textAlign: "center" }}>
          {(logs.earlycoming)? logs.earlycoming : ""}
        </TableCell>
        )}
        <TableCell style={{ textAlign: "center" }}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            onClick={ this.handleToggle.bind(this, index)}
            className="cursurpointer"
          >
            <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
          </svg>
        </TableCell>
        <Popper
          open={logs.open}
          anchorEl={this.state.anchorEl}
          transition
          disablePortal
          className="attendancelog-menu"
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "right top" : "right bottom",
              }}
            >
              <Paper>
                <ClickAwayListener
                  onClickAway={this.handleClose.bind(this, index)}
                >
                  <MenuList>
                    {istoday(logs.shiftdate) && (
                      <MenuItem
                        onClick={this.toggleDrawer("right", true, "IsClockin", {
                          shiftdate: logs.shiftdate,
                          shiftid: logs.shiftid,
                          shifttimingid: logs.shifttimingid,
                        })}
                      >
                        Clock-in
                      </MenuItem>
                    )}
                    <MenuItem
                      onClick={this.toggleDrawer("right", true, "AllLogs", {
                        shiftdate: logs.shiftdate,
                        shiftid: logs.shiftid,
                        shifttimingid: logs.shifttimingid,
                      })}
                    >
                      View all logs
                    </MenuItem>
                    {
                      <MenuItem
                        onClick={this.toggleDrawer(
                          "right",
                          true,
                          "currentshift",
                          {
                            shiftdate: logs.shiftdate,
                            shiftid: logs.shiftid,
                            shifttimingid: logs.shifttimingid,
                          },
                        )}
                      >
                        View Shift & policy info
                      </MenuItem>
                    }
                    {deleteAttendancelogs &&
                    deleteAttendancelogs.permissions.editable &&
                    logs.intime ? (
                      <MenuItem
                        onClick={this.DeleteAttendanceLog.bind(this, logs)}
                      >
                        Delete all logs
                      </MenuItem>
                    ) : undefined}
    
                  {/* { checkbulkreg && checkbulkreg.permissions.editable &&
                    logs.intime ? (
                      <MenuItem
                      onClick={this.toggleDrawer(
                        "right",
                        true,
                        "BulkRegularize",
                        logs
                      )}
                      >
                        Attendance update
                      </MenuItem>
                    ) : undefined} */}

                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </TableRow>
    );
  };

  DownloadAtteLogs() {
    const rows = [
      [
        "Date",
        "Attendance Status",
        "in Time",
        "Out Time",
        "Work Duration",
        "Break Duration",
        "Over Time",
        "Late By",
        "Early By",

        // "Request Status",
      ],
    ];
    // const { selectedDate, value, open, TimeFormat, ShortDateFormat, totalduration, overview, averageduration, employeeattendancelog } = this.state;
    const { selectedDate, TimeFormat, employeeattendancelogAdvanced } = this.state;
    const demployeeattendancelog = employeeattendancelogAdvanced;
    demployeeattendancelog.forEach((logs) => {
      logs.shiftdate = getFormattedDate(logs.shiftdate);
      logs.intime = logs.intime ? getFormattedTimewithAll(logs.intime, TimeFormat): "";
      logs.outtime = logs.outtime ? getFormattedTimewithAll(logs.outtime, TimeFormat): "";
      logs.workduration = logs.workduration ? logs.workduration: "";
      logs.breakduration = logs.breakduration ? logs.breakduration: "";
      logs.overtime = logs.overtime ? logs.overtime: "";
      logs.lateby = logs.lateby ?logs.lateby: "";
      logs.earlycoming = logs.earlycoming ? logs.earlycoming: "";
      // logs.intime = TimeConversion(logs.intime, TimeFormat);
      // logs.outtime = TimeConversion(logs.outtime, TimeFormat);
      logs.attendancestatus = logs.statusstring; // this.AttendanceStatus(logs);
      rows.push([
        logs.shiftdate,
        logs.attendancestatus,
        logs.intime,
        logs.outtime,
        logs.workduration,
        logs.breakduration,
        logs.overtime,
        logs.lateby,
        logs.earlycoming,

        // logs.requeststatus,
      ]);
    });
    const csvContent = rawDataIntoExcel(rows);
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute(
      "download",
      `Attendance_log ${moment(selectedDate).format("MMM, YYYY")}.csv`,
    );
    document.body.appendChild(link);
    link.click();
    //this.GetAttendanceLog(1);
  }

  render() {
    const Today = new Date(this.state.selectedshiftdate);
    const { masterprofileid } = this.props.AuthenticationAction.login;

    const checkbulkreg = this.props.AuthenticationAction.login.features.find(
      (feature) => feature.featureid == FEATUREKEYS.updateAttendancelogs,
    );
    const checkautoreg = this.props.AuthenticationAction.login.features.find(
      (feature) => feature.featureid == FEATUREKEYS.autoRegularize,
    );
    const workRequest = this.props.AuthenticationAction.login.features.find(
      (feature) => feature.featureid == FEATUREKEYS.workRequest,
    );
    const clockinRequest = this.props.AuthenticationAction.login.features.find(
      (feature) => feature.featureid == FEATUREKEYS.clockinRequest,
    );

    Today.setDate(Today.getDate() + 1);
    const { classes } = this.props;
    const language = this.props.Language.attendancelogs;

    const {
      totalduration,
      overview,
      averageduration,
      employeeattendancelog,
      employeeattendancelogAdvanced,
      SelectedEmpData,
      isFromModule,
      datareceived,
      policyAssigned,
      openOptions,
      showDiv,
      showLogDetail,
      presentDays,
      absentDays,
      leaveDays,
      isDisable
      // selectedshiftdateObj,
      // recipient,
    } = this.state;

    const migratattendance =
      this.props.AuthenticationAction.login.migration.find(
        (x) => x.moduletypeid == 1,
      );
    console.log("migratattendance: ", migratattendance);
    return (
      <div className="application">
        {isFromModule ? (
          <Helmet>
            <meta charSet="utf-8" />
            <title>{headersList.Attendance.StartAttendence.header}</title>
          </Helmet>
        ) : (
          <Helmet>
            <meta charSet="utf-8" />
            <title>{headersList.Attendance.Attendence.header}</title>
          </Helmet>
        )}
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : this.state.isloading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <img className="loader" src={loader} />
          </div>
        ) : (
          <div>
            <Drawer
              show={this.state.right}
              onClose={this.toggleDrawer("right", false)}
            >
              <div className="padding15">
                {this.state.right ? (
                  <div>
                    {!this.state.bulkRegularize &&
                      !this.state.AllLogs &&
                      !this.state.currentShift && (
                        <DrawerHeader
                          header={
                            this.state.IsClockin ? (
                              <FormattedMessage
                                id="LbClockInRequest"
                                defaultMessage="Clock in request"
                              />
                            ) : this.state.Workrequest ? (
                              <span>Work From Home/ Out Duty Request</span>
                            ) : this.state.autoRegularize ? (
                              <FormattedMessage
                                id="LbAutoregularize"
                                defaultMessage="Auto Regularize"
                              />
                            ) : this.state.extratime ? (
                              <span>Extra time Request</span>
                            ) : (
                              " "
                            )
                          }
                          isbackarrow={false}
                          closeDrawer={this.toggleDrawer("right", false)}
                        />
                      )}

                    <DrawerComponent
                      closeDrawer={this.closeDrawer}
                      GetAttendanceLog={this.GetAttendanceLog}
                      {...this.state}
                      {...this.props}
                    />
                  </div>
                ) : null}
              </div>
            </Drawer>

            <IntlProvider locale="en" messages={language}>
              <main
                className={
                  isFromModule
                    ? "content-outer-wrapper-with-tab"
                    : "content-outer-wrapper"
                }
              >
                <Grid container className="position-rel">
                  <Grid item xs={12} md={12} sm={12}>
                    <PageHeader
                      header={
                        isFromModule
                          ? "Employee attendance data"
                          : "My attendance"
                      }
                    />
                    <Grid
                      container
                      className="abcd"
                      style={{ marginTop: isFromModule ? "" : "-65px" }}
                    >
                      <Grid item xs={4} md={10} sm={10}>
                        {isFromModule && (
                          <div>
                            <span className="floatleft margin-right-16">
                              {isFromModule &&
                                (masterprofileid == 9 ? (
                                  <Select
                                    className="selectsearch inlindClass width250"
                                    onChange={this.UpdateSelectedEmpId.bind(
                                      this,
                                    )}
                                    onInputChange={this.SearchEmployee}
                                    options={this.state.empList}
                                    getOptionLabel={(option) =>
                                      option.displayname
                                    }
                                    getOptionValue={(option) =>
                                      option.displayvalue
                                    }
                                    value={this.state.SelectedEmpData}
                                    placeholder="Search Employee"
                                    isClearable={true}
                                  />
                                ) : (
                                  this.state.empList1 &&
                                  this.state.empList1.length > 0 && (
                                    <Select
                                      className="selectsearch width250"
                                      onChange={this.UpdateSelectedEmpId1.bind(
                                        this,
                                      )}
                                      options={this.state.empList1}
                                      getOptionLabel={(option) =>
                                        option.displayname
                                      }
                                      getOptionValue={(option) =>
                                        option.displayvalue
                                      }
                                      value={this.state.SelectedEmpData}
                                      placeholder="Select Employee"
                                    />
                                  )
                                ))}
                            </span>
                            <span className="floatleft" style={{width:"72%"}}>
                              {SelectedEmpData && policyAssigned ? (
                                <CallOutNew
                                  classnames="bg-light-blue width100"
                                  header="Attendance logs of the selected employee is displayed below."
                                  emoji="🔍 👩🏻‍💼 ⏱"
                                  textcolor="#1e8ced"
                                />
                              ) : (
                                <CallOutNew
                                  classnames="bg-light-blue width100"
                                  header="Search and select the employee whose attendance logs you wish to see."
                                  emoji="🔍 👩🏻‍💼 ⏱"
                                  textcolor="#1e8ced"
                                />
                              )}
                            </span>
                          </div>
                        )}
                      </Grid>
                      <Grid item xs={4} md={2} sm={2}>
                        {
                          <div
                            style={{
                              float: "right",
                              marginTop: !isFromModule && 16,
                              width: !isFromModule && 400,
                            }}
                          >
                            {!isFromModule &&
                              migratattendance &&
                              migratattendance.isenable && (
                                <div
                                  style={{
                                    float: `${
                                      policyAssigned ? "left" : "right"
                                    }`,
                                    width: 240,
                                    marginTop: 8,
                                    color: "#057cff",
                                    fontWeight: 400,
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    window.open(migratattendance.oldurl);
                                  }}
                                >
                                  View attendance in sumHR 2.0
                                </div>
                              )}
                            {policyAssigned && (
                              <DatePickerComponent
                                placeholder="Choose month"
                                allowEdit={false}
                                border="1px solid #166ab3 !important"
                                format={getEJ2CalenderMonthFormat()}
                                width={isFromModule ? "100%" : "38%"}
                                // // onClick={() => this.dateObj.show()}
                                // ref={(date1) => {
                                //   this.dateObj = date1;
                                // }}
                                className={
                                  !isFromModule && migratattendance
                                    ? "datepicker-back floatleft"
                                    : "datepicker-back floatright"
                                }
                                max={new Date()}
                                min={this.state.empdoj && this.state.empdoj}
                                depth="Year"
                                start="Decade"
                                disabled={!SelectedEmpData && isFromModule}
                                change={this.dateOnSelect.bind(this)}
                                value={this.state.selectedDate}
                                hideClearIcon
                              />
                            )}
                          </div>
                        }
                      </Grid>
                    </Grid>

                    {(SelectedEmpData || !isFromModule) && policyAssigned && (
                      <Grid container className="margin-bottom-4 margin-top-16" spacing={2}>
                        <Grid item xs={4} md={4} sm={8}>
                          <div className="attendance-log-action-wrapper" >
                            {clockinRequest && clockinRequest.permissions.editable && (
                                <div className="attendance-log-action">
                                  <Button
                                    className="attendance-log-action-btn IsClockin "
                                    variant="outlined"
                                    color="primary"
                                    size="large"
                                    onClick={this.toggleDrawer(
                                      "right",
                                      true,
                                      "IsClockin",
                                    )}
                                    style={{marginLeft: -18}}
                                  >
                                    Clock-in Request
                                  </Button>
                                </div>
                              )}
                          </div>
                          </Grid>
                          <Grid item xs={4} md={4} sm={8}>
                          <div className="attendance-log-action-wrapper">
                            {checkbulkreg && checkbulkreg.permissions.editable && (
                              <div className="attendance-log-action">
                                <Tooltip
                                  title="Regularization"
                                  placement="top-start"
                                >
                                  <Button
                                    className="attendance-log-action-btn BulkRegularize"
                                    variant="outlined"
                                    color="primary"
                                    size="large"
                                    onClick={this.toggleDrawer(
                                      "right",
                                      true,
                                      "BulkRegularize",
                                    )}
                                    style={{marginLeft: -40}}
                                  >
                                    <FormattedMessage
                                      id="_LbAttendanceupdate"
                                      defaultMessage="Attendance update"
                                    />
                                  </Button>
                                </Tooltip>
                              </div>
                            )}
                            {/* {workRequest && workRequest.permissions.editable && (
                              <div className="attendance-log-action">
                                <Button
                                  className="attendance-log-action-btn WorkRequest"
                                  variant="outlined"
                                  color="primary"
                                  size="large"
                                  onClick={this.toggleDrawer(
                                    "right",
                                    true,
                                    "WorkRequest",
                                  )}
                                >
                                  <span>WFH/ OD Request</span>
                                </Button>
                              </div>
                            )}
                            {workRequest && workRequest.permissions.editable && (
                              <div className="attendance-log-action">
                                <Button
                                  className="attendance-log-action-btn WorkRequest"
                                  variant="outlined"
                                  color="primary"
                                  size="large"
                                  onClick={this.toggleDrawer(
                                    "right",
                                    true,
                                    "extratime",
                                  )}
                                >
                                  <span>Extra time Request</span>
                                </Button>
                              </div>
                            )}
                            {checkbulkreg && checkbulkreg.permissions.editable && (
                              <div className="attendance-log-action">
                                <Tooltip
                                  title="Regularization"
                                  placement="top-start"
                                >
                                  <Button
                                    className="attendance-log-action-btn BulkRegularize"
                                    variant="outlined"
                                    color="primary"
                                    size="large"
                                    onClick={this.toggleDrawer(
                                      "right",
                                      true,
                                      "BulkRegularize",
                                    )}
                                  >
                                    <FormattedMessage
                                      id="_LbAttendanceupdate"
                                      defaultMessage="Attendance update"
                                    />
                                  </Button>
                                </Tooltip>
                              </div>
                            )}
                            {checkautoreg &&
                            get(checkautoreg, "permissions.editable", "") ? (
                              <div className="attendance-log-action">
                                <Button
                                  className="attendance-log-action-btn AutoRegularize"
                                  variant="outlined"
                                  color="primary"
                                  size="large"
                                  onClick={this.toggleDrawer(
                                    "right",
                                    true,
                                    "AutoRegularize",
                                  )}
                                >
                                  <FormattedMessage
                                    id="LbAutoregularize"
                                    defaultMessage="Auto Regularize"
                                  />
                                </Button>
                              </div>
                            ) : (
                              ""
                            )} */}
                          </div>
                        </Grid>
                        
                        <Grid item xs={4} md={4} sm={4}>
                          <div
                            //onClick={() => this.openOptions(true)}
                            className="profile-more-options-icon"
                            >
                            <span
                              className="rounded-rectangle-div margin-right-16"
                              style={{
                                padding: "8px 5px 8px 51px",
                                marginRight: 10,
                                width: 194,
                                display: "flex",
                                height: 23,
                                alignItems: "center",
                                cursor: "pointer",
                                marginLeft: -54,
                              }}
                              onClick={() => this.openOptions(true)}
                            >
                              <p className="small-dark-secondary">
                              Advanced options 
                              </p>
                              <img style={{ paddingLeft: 10 }} src={settingsIcon}></img>
                            </span>
                            {/* Advanced Options <i className="material-icons floatleft">more_vert</i> */}
                            <Popper
                              open={openOptions}
                              anchorEl={this.state.showAdvanceOption ? this.state.anchorEl1 : this.state.anchorEl}
                              transition
                              disablePortal
                              className="profile-more-options"
                            >
                              {({ TransitionProps, placement }) => (
                                <Grow
                                  {...TransitionProps}
                                  style={{
                                    transformOrigin:
                                      placement === "bottom" ? "right top" : "right bottom",
                                  }}
                                >
                                        <Paper>
                                          <ClickAwayListener
                                            onClickAway={() => this.openOptions(false)}
                                          >
                                            <MenuList>
                                                {workRequest && workRequest.permissions.editable && (
                                                  <div className="attendance-log-action">
                                                    <MenuItem
                                                      className="attendance-log-action-btn WorkRequest"
                                                      variant="outlined"
                                                      color="primary"
                                                      size="large"
                                                      onClick={this.toggleDrawer(
                                                        "right",
                                                        true,
                                                        "WorkRequest",
                                                      )}
                                                    >
                                                      <span>WFH/ OD Request</span>
                                                    </MenuItem>
                                                  </div>
                                                )}
                                                {workRequest && workRequest.permissions.editable && (
                                                  <div className="attendance-log-action">
                                                    <MenuItem
                                                      className="attendance-log-action-btn WorkRequest"
                                                      variant="outlined"
                                                      color="primary"
                                                      size="large"
                                                      onClick={this.toggleDrawer(
                                                        "right",
                                                        true,
                                                        "extratime",
                                                      )}
                                                    >
                                                      <span>Extra time Request</span>
                                                    </MenuItem>
                                                  </div>
                                                )}
                                              {checkautoreg &&
                                                get(checkautoreg, "permissions.editable", "") ? (
                                                  <div className="attendance-log-action">
                                                    <MenuItem
                                                      className="attendance-log-action-btn AutoRegularize"
                                                      variant="outlined"
                                                      color="primary"
                                                      size="large"
                                                      onClick={this.toggleDrawer(
                                                        "right",
                                                        true,
                                                        "AutoRegularize",
                                                      )}
                                                    >
                                                      <FormattedMessage
                                                        id="LbAutoregularize"
                                                        defaultMessage="Auto Regularize"
                                                      />
                                                    </MenuItem>
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                            
                                    </MenuList>
                                  </ClickAwayListener>
                                </Paper>
                              </Grow>
                            )}
                          </Popper>
                        </div>
                        </Grid>
                      </Grid>
                    )}

                    {!SelectedEmpData}
                  </Grid>
                  { (datareceived && policyAssigned)  && (SelectedEmpData || !isFromModule) && (
                  <Grid item xs={12} md={12} sm={12} style={{marginTop:7}}>
                    <Grid container>
                      <Card className="width100">
                      {/* <CardContent> */}
                      <table className="width100" ><tr>
                      <td style={{textAlign: "left", paddingLeft: 20}}>
                        <tr>
                          <td>Present Days </td>
                          <td><img src={rightArrow} alt="" height="18" style={{ marginTop: 5,padding:2}} /></td>
                          <td>{presentDays}</td>
                        </tr>
                      </td> 
                      {/* <td style={{textAlign: "left", paddingLeft: 20}}>
                      <tr>
                          <td>Leave Days </td>
                          <td><img src={rightArrow} alt="" height="18" style={{ marginTop: 5,padding:2}} /></td>
                          <td>{leaveDays}</td>
                      </tr>
                      </td> */}
                      <td style={{textAlign: "left", paddingLeft: 20}}>
                      <tr>
                          <td>Absent Days </td>
                          <td><img src={rightArrow} alt="" height="18" style={{ marginTop: 5,padding:2}} /></td>
                          <td>{absentDays}</td>
                      </tr>
                      </td>
                      <td style={{textAlign: "right"}}>        
                        <a 
                              onClick={() => this.toggleDivAttendanceSummary()}
                              disabled={
                                this.props.SaveInProgressReducer.issaveinprogress
                              } >
                                <div style={{ marginTop: 5 }}>
                                  
                                  {this.state.showDiv ? (
                                      <img
                                      style={{paddingRight:18}}
                                      src={downArrow}
                                      alt=""
                                      height="24"
                                    />
                                    ) : (
                                      <img
                                      style={{paddingRight:7}}
                                      src={rghtArow}
                                      alt=""
                                      height="24"
                                    />
                                    )}
                                </div>
                        </a>
                      </td>
                      </tr></table> 
                      {/* </CardContent> */}
                      </Card>
                    </Grid>
                  </Grid>
                  )}
                  {datareceived &&
                    (policyAssigned ? (
                      <Grid item xs={12} md={12} sm={12} >
                      <div className="width100">
                        { showDiv && (SelectedEmpData || !isFromModule) && (
                          <Grid item xs={12} md={12} sm={12} style={{margin:"20px 0px -9px"}}>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={4} sm={4}>
                                <Paper >
                                  <div className="log-summary">
                                    <Grid
                                      container
                                      className="padding-bottom-10"
                                    >
                                      <Grid item xs={12} md={12} sm={12}>
                                        <div
                                          align="center"
                                          className="request-mainhead ellipsis"
                                        >
                                          <span>
                                            <img src={clock} height="14" />
                                          </span>
                                          <span className="margin-left-10 text-color-blue">
                                            <FormattedMessage
                                              id="Lboverview"
                                              defaultMessage="Overview"
                                            />
                                          </span>
                                        </div>
                                      </Grid>
                                    </Grid>

                                    {overview.map((option) => (
                                      <Grid container>
                                        <Grid item xs={12} md={6} sm={10}>
                                          <div className="t-16 line-height-32 ellipsis">
                                            {option.displayname}
                                          </div>
                                        </Grid>
                                        <Grid item xs={12} md={6} sm={2}>
                                          <div className="floatright t-16 line-height-32 ellipsis">
                                            {option.displayvalue}
                                          </div>
                                        </Grid>
                                      </Grid>
                                    ))}
                                  </div>
                                </Paper>
                              </Grid>
                              <Grid item xs={12} md={4} sm={4}>
                                <Paper>
                                  <div className="log-summary">
                                    <Grid
                                      container
                                      className="padding-bottom-10"
                                    >
                                      <Grid item xs={12} md={12} sm={12}>
                                        <div
                                          align="center"
                                          className="request-mainhead ellipsis"
                                        >
                                          <span>
                                            <img src={clock} height="14" />
                                          </span>
                                          <span className="margin-left-10 text-color-blue">
                                            <FormattedMessage
                                              id="Lbtotalduration"
                                              defaultMessage="Total Duration"
                                            />
                                          </span>
                                        </div>
                                      </Grid>
                                    </Grid>
                                    {totalduration.map((option) => (
                                      <Grid container>
                                        <Grid item xs={12} md={6} sm={10}>
                                          <div className="t-16 line-height-32 ellipsis">
                                            {option.displayname}
                                          </div>
                                        </Grid>
                                        <Grid item xs={12} md={6} sm={2}>
                                          <div className="floatright line-height-32 t-16 ellipsis">
                                            {option.displayvalue}
                                          </div>
                                        </Grid>
                                      </Grid>
                                    ))}
                                  </div>
                                </Paper>
                              </Grid>
                              <Grid item xs={12} md={4} sm={4}>
                                <Paper>
                                  <div className="log-summary">
                                    <Grid
                                      container
                                      className="padding-bottom-10"
                                    >
                                      <Grid item xs={12} md={12} sm={12}>
                                        <div
                                          align="center"
                                          className="request-mainhead ellipsis"
                                        >
                                          <span>
                                            <img src={clock} height="14" />
                                          </span>
                                          <span className="margin-left-10 text-color-blue">
                                            <FormattedMessage
                                              id="Lbaverageduration"
                                              defaultMessage="Average Duration"
                                            />
                                          </span>
                                        </div>
                                      </Grid>
                                    </Grid>
                                    {averageduration.map((option) => (
                                      <Grid container>
                                        <Grid item xs={12} md={6} sm={10}>
                                          <div className="t-16 line-height-32 ellipsis">
                                            {option.displayname}
                                          </div>
                                        </Grid>
                                        <Grid item xs={12} md={6} sm={2}>
                                          <div className="floatright t-16 line-height-32 ellipsis">
                                            {option.displayvalue}
                                          </div>
                                        </Grid>
                                      </Grid>
                                    ))}
                                  </div>
                                </Paper>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                        
                          <Grid item xs={12} md={12} sm={12} style={{display:"flex",justifyContent:"right",marginTop:8}}>
                          <div
                             // className="rounded-rectangle-div"
                              style={{
                                padding: "8px 0px 8px 0px",
                                margin: "16px 0px",
                                // width: 195,
                                display: "flex",
                                //height: 25,
                                // alignItems: "center",
                                cursor: "pointer",
                                // float:"right",
                                textDecoration:"underline",
                                // color:"#1E8CED",
                                
                                textAlign:"right"
                              }}
                              onClick={this.handleClickShowLogDetail} 
                              disabled={
                                this.props.SaveInProgressReducer.issaveinprogress
                              }
                            >
                              <div>
                               
                              <InputAdornment position="end" className="normal-dark-secondary">
                                 Additional log details
                                  <IconButton
                                    className="ShowPassword"
                                    aria-label="Toggle password visibility"
                                    //onClick={this.handleClickShowLogDetail}
                                    style={{ textDecoration:"underline",
                                      display:"inline-block",
                                    marginLeft:8}}
                                  >
                                    {this.state.showLogDetail ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              </div>
                          </div>
                          </Grid> 
                        
                          {(SelectedEmpData || !isFromModule) && (
                             
                            
                            <Grid
                              item
                              xs={12}
                              md={12}
                              sm={12}
                              className="width100"
                             
                            >
                             {this.state.isloader 
                              ? <div  style={{display:"flex",justifyContent:"center"}} >
                              <img style={{height:80,width:80}} src={loader} /></div>
                                :
                              <SimpleTable
                                headerData={ showLogDetail ? this.state.headerData : this.state.headerData2 }
                                rowsData={showLogDetail ? employeeattendancelogAdvanced : employeeattendancelog }
                                jsx={this.renderLogs}
                              /> 
                             }
                            </Grid>
                            
                          )}
                        
                      </div>
                      </Grid>
                    ) : (
                      <div className="margin-top-16 width100">
                        {SelectedEmpData && isFromModule && (
                          <div className="position-rel">
                            <DefaultComp
                              heading="There is no attendance policy assigned yet!"
                              subheading="You can only view attendance logs after a policy has been assigned."
                              imageSrc={attendanceimg}
                            />
                          </div>
                        )}
                        {SelectedEmpData == null && !isFromModule && (
                          <div className="position-rel">
                            {/* <DefaultComp
                            heading="There is no attendance policy assigned yet!"
                            subheading="You can only view your attendance logs after a policy has been assigned."
                            imageSrc={attendanceimg}
                          /> */}
                            <Grid
                              container
                              className="empty-state-illustration"
                              style={{ marginTop: 50 }}
                            >
                              <Grid container className="padding0 text-center">
                                <div className="width100">
                                  <img
                                    src={syncimg}
                                    style={{ width: 218, height: 218 }}
                                  />

                                  <div className="text-center margin-bottom-24">
                                    <Button
                                      variant="contained"
                                      className="btn btn-primary-md-blue"
                                      color="primary"
                                      onClick={this.syncapp}
                                      endIcon={<img src={Reload}></img>}
                                    >
                                      Sync app
                                    </Button>
                                  </div>

                                  <div className="headline-h3 margin-bottom-8 margin-top-24 text-align-center">
                                    Please sync-app to check your shift
                                    assignments.
                                  </div>
                                  <p className="normal-dark-secondary margin-top-128">
                                    PS: already synced app but still don’t see
                                    your attendance? Maybe there’s no shift
                                    assigned to you yet. <br></br> Please
                                    contact your HR team!
                                  </p>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                        )}
                      </div>
                    ))}
                </Grid>
              </main>
            </IntlProvider>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  SubscriptionInfo: state.SubscriptionInfo,
  AuthenticationAction: state.AuthenticationAction,
  Language: state.LanguageAction.Language,
  FCMReducer: state.FCMReducer,
  SaveInProgressReducer: state.SaveInProgressReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      setSaveProgress,
      removeSaveProgress,
      updateAuthentication,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(AttendanceLog)));
